// extracted by mini-css-extract-plugin
export default {"wrapper":"BrowserPermission_wrapper__lHN6b","permission":"BrowserPermission_permission__czERV","icon":"BrowserPermission_icon__2cydR"};